var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFanhuichuangkou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7V2.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v11a.5.5 0 01-.5.5H9",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0.25,
    transform: "matrix(-1 0 0 1 7 9)",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5l-3 3m0 0V5m0 2.5H11",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgN1YyLjVDMiAyLjIyMzg2IDIuMjIzODYgMiAyLjUgMkgxMy41QzEzLjc3NjEgMiAxNCAyLjIyMzg2IDE0IDIuNVYxMy41QzE0IDEzLjc3NjEgMTMuNzc2MSAxNCAxMy41IDE0SDkiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxyZWN0IHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHJ4PSIwLjI1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA3IDkpIiBzdHJva2U9IiMzRjQ2NUMiLz4KPHBhdGggZD0iTTExLjUgNC41TDguNSA3LjVNOC41IDcuNUw4LjUgNU04LjUgNy41TDExIDcuNSIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgTongyongFanhuichuangkou as ReactComponent };